// Content + mock data. The canonical moment definitions come from @wedding/shared;
// here we attach mock photo counts so the UI is fully clickable before the API is wired.
import { MOMENTS as SHARED_MOMENTS, SUGGESTED_SEARCHES } from "@wedding/shared";
import type { CSSProperties } from "react";

export interface MomentView {
  id: string; // = shared key
  name: string; // = shared label
  desc: string;
  kw: string[];
  wash: [string, string];
  count: number;
}

// Mock counts for the demo view (replaced by real counts once the API is live).
const MOCK_COUNTS: Record<string, number> = {
  ceremony: 295,
  "ring-exchange": 47,
  "first-kiss": 73,
  cocktail: 118,
  "grand-entrance": 52,
  toasts: 84,
  cake: 67,
  "dance-floor": 426,
  uncategorized: 14,
  videos: 8,
};

export const MOMENTS: MomentView[] = SHARED_MOMENTS.map((m) => ({
  id: m.key,
  name: m.label,
  desc: m.desc,
  kw: m.keywords,
  wash: m.wash,
  count: MOCK_COUNTS[m.key] ?? 0,
}));

export const SUGGESTED = SUGGESTED_SEARCHES;

export const SUCCESS_NAMES = ["Abbie", "Taner", "the Hagemans", "Sophia", "the dance floor", "golden hour"];

// deterministic soft wash recipes for placeholder tiles
const WASHES: [string, string, string, string][] = [
  ["155deg", "#f6d7e4", "#e7b7cd", "#cdd9e3"],
  ["165deg", "#dfe7ec", "#cdd9e3", "#e9c4d4"],
  ["135deg", "#f1e2d4", "#e7c9b3", "#d9b9c8"],
  ["145deg", "#e7d4e0", "#c79bc0", "#dcc0a6"],
  ["170deg", "#f4d8c0", "#e6a982", "#e9c4d4"],
  ["150deg", "#dde6e4", "#b6cabf", "#e7d3c2"],
  ["140deg", "#f3c9da", "#dd6fa6", "#f0e0cb"],
  ["160deg", "#ece2d0", "#d8c39a", "#cdd9e3"],
];

export function washFor(seed: number): CSSProperties {
  const w = WASHES[Math.abs(seed) % WASHES.length]!;
  return {
    backgroundImage:
      `radial-gradient(120% 90% at 25% 20%, rgba(255,255,255,0.55), rgba(255,255,255,0) 55%),` +
      `radial-gradient(100% 80% at 80% 90%, ${w[3]}, rgba(255,255,255,0) 60%),` +
      `linear-gradient(${w[0]}, ${w[1]}, ${w[2]})`,
  };
}
